import React from 'react';
import  './Card.scss';

const Card=(props)=>{
    return(
        <div className={`feature-card1 ${props.styles}`}>
            <div style={{ backgroundColor: `${props.color}` }} className="circle">
               <img src={props.icon} />
            </div>
               <h2>{props.title}</h2>
               <p>{props.desc}</p>
        </div>
    )
};
export default Card ;